import { T_ApiResponse } from "../../globalTypes/GlobalTypes";
import { CSApiService } from "../../redux-store/CSApiService";
import {
  Api_DelinkFolioList,
  Api_DownloadCapitalStatementNew,
  Api_ExitLoad,
  Api_FolioLinkingDelinking,
  APi_FolioSchemeSummary,
  Api_FoliosSummary,
  Api_LastTransactionBroker,
  Api_ValidatePan,
  Api_AccountStatementNew,
  Api_Delete_Secoundary_Holding,
} from "../../utils/ApiEndpoints";
import { getCurrentDateTimeStamp } from "../../utils/helper";

import {
  T_FetchAccountStatement_Request,
  T_FetchAccountStatement_Response,
  T_FetchExitLoad_ReqPayload,
  T_FetchExitLoad_Response,
  DownloadCapitalGainStatement_Request,
  DownloadCapitalGainStatement_Response,
  T_FolioSchemeSummary_Request,
  T_FolioSchemeSummary_Response,
  T_FoliosSummary_Request,
  T_FoliosSummary_Response,
  T_ValidatePan_Request,
  T_ValidatePan_Response,
  T_LastTransactionBroker_Request,
  T_LastTransactionBroker_Response,
  T_DelinkFolioList_Response,
  T_DelinkFolioList_Request,
  T_FolioLinkingDeLinking_Response,
  T_FolioLinkingDeLinking_Request,
  T_DeleteSecoundaryHolding_Response,
  T_DeleteSecoundaryHolding_Request,
} from "./MutualFund_Types";

export const MutualFundApi = CSApiService.injectEndpoints({
  endpoints: (builder) => ({
    exitLoad: builder.query<
      T_ApiResponse<T_FetchExitLoad_Response>,
      T_FetchExitLoad_ReqPayload
    >({
      providesTags: ["MF_EXIT_LOAD"],
      query: (apiBody) => ({
        url: Api_ExitLoad,
        method: "POST",
        body: apiBody,
      }),
    }),
    downloadCapitalGainStatement: builder.query<
      T_ApiResponse<DownloadCapitalGainStatement_Response>,
      DownloadCapitalGainStatement_Request
    >({
      query: (payload) => ({
        url: Api_DownloadCapitalStatementNew,
        method: "POST",
        body: payload,
      }),
    }),
    validatePan: builder.query<
      T_ApiResponse<T_ValidatePan_Response>,
      T_ValidatePan_Request
    >({
      providesTags: ["MF_VALIDATE_PAN"],
      query: (payload) => ({
        url: Api_ValidatePan,
        method: "POST",
        body: payload,
        headers: {
          csUserId: "123",
          ciiNumber: "1234",
        },
      }),
    }),
    fetchFoliosSummary: builder.query<
      T_ApiResponse<T_FoliosSummary_Response>,
      T_FoliosSummary_Request
    >({
      providesTags: ["MF_FOLIOS_SUMMARY"],
      query: (apiBody) => ({
        url: Api_FoliosSummary,
        method: "POST",
        body: apiBody,
      }),
    }),
    fetchFolioSchemeSummary: builder.query<
      T_ApiResponse<T_FolioSchemeSummary_Response>,
      T_FolioSchemeSummary_Request
    >({
      providesTags: ["MF_FOLIO_SCHEME_SUMMARY"],
      query: (apiBody) => ({
        url: APi_FolioSchemeSummary,
        method: "POST",
        body: apiBody,
      }),
    }),
    accountStatement: builder.query<
      T_ApiResponse<T_FetchAccountStatement_Response>,
      T_FetchAccountStatement_Request
    >({
      query: (payload) => ({
        url: Api_AccountStatementNew,
        method: "POST",
        body: payload,
      }),
    }),
    lastTransactionBroker: builder.query<
      T_ApiResponse<T_LastTransactionBroker_Response>,
      T_LastTransactionBroker_Request
    >({
      query: (payload) => ({
        url: Api_LastTransactionBroker,
        method: "POST",
        body: payload,
      }),
    }),
    fetchDelinkFolioList: builder.query<
      T_ApiResponse<T_DelinkFolioList_Response>,
      T_DelinkFolioList_Request
    >({
      query: (payload) => ({
        url: Api_DelinkFolioList,
        method: "POST",
        body: {
          getDelinkFolioListRequest: payload,
        },
      }),
    }),
    folioLinkingDelinking: builder.query<
      T_ApiResponse<T_FolioLinkingDeLinking_Response>,
      T_FolioLinkingDeLinking_Request
    >({
      query: (payload) => ({
        url: Api_FolioLinkingDelinking,
        method: "POST",
        body: {
          folioLinkDelinkRequest: payload,
        },
      }),
    }),
    deleteSecoundaryHolding: builder.mutation<
      T_ApiResponse<T_DeleteSecoundaryHolding_Response>,
      T_DeleteSecoundaryHolding_Request[]
    >({
      query: (payload) => ({
        method: "POST",
        url: Api_Delete_Secoundary_Holding,
        data: payload,
      }),
    }),
  }),
});

export const {
  useLazyExitLoadQuery,
  useLazyValidatePanQuery,
  useLazyFetchFoliosSummaryQuery,
  useLazyFetchFolioSchemeSummaryQuery,
  useLazyDownloadCapitalGainStatementQuery,
  useLazyAccountStatementQuery,
  useLazyLastTransactionBrokerQuery,
  useLazyFetchDelinkFolioListQuery,
  useLazyFolioLinkingDelinkingQuery,
  useDeleteSecoundaryHoldingMutation,
} = MutualFundApi;
